import { render } from "./TestCasesValidationsTable.vue?vue&type=template&id=91b7ae42&scoped=true"
import script from "./TestCasesValidationsTable.vue?vue&type=script&lang=js"
export * from "./TestCasesValidationsTable.vue?vue&type=script&lang=js"

import "./TestCasesValidationsTable.vue?vue&type=style&index=0&id=91b7ae42&lang=scss&scoped=true"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-91b7ae42"]])

export default __exports__
import QTable from 'quasar/src/components/table/QTable.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QTable});
